
import Keycloak, { KeycloakInitOptions } from 'keycloak-js';
import { EnvService } from './services/env.service';
// Create a singleton to hold Keycloak instance globally in your app
export let keycloakInstance: Keycloak | null = null;

export function initializeKeycloak(env: EnvService) {
  return (): Promise<boolean> => {
    const keycloak = new Keycloak({
      url: env.keyCloakUrls.baseUrl,
      realm: env.keyCloakOptions.realm,
      clientId: env.keyCloakOptions.clientId
    });

    keycloakInstance = keycloak; // store it globally if needed later

    const initOptions: KeycloakInitOptions = {
      onLoad: 'check-sso',
      checkLoginIframe: true,
      checkLoginIframeInterval: 100,
      silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
    };
    

    console.log('Starting Keycloak init...');
    
    // Initialize Keycloak and return promise so Angular waits
    return keycloak.init(initOptions).then(authenticated => {
      console.log('Keycloak initialized, authenticated:', authenticated);
      return authenticated;
    }).catch(err => {
      console.error('Keycloak init failed', err);
      return false; // or reject the promise if you want to block app start
    });
  };
}

